var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { Room as RoomModel } from '@/models/Room';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { LessonType } from '@/models/LessonType';
import { Level } from '@/models/Level';
import AddLessonTypeDialog from '@/views/Rooms/AddLessonTypeDialog';
import AddLevelDialog from '@/views/Rooms/AddLevelDialog';
let Room = class Room extends Vue {
    constructor() {
        super(...arguments);
        this.room = null;
        this.editableRoom = null;
        this.lessonTypes = [];
        this.levels = [];
        this.selectedLessonTypes = [];
        this.selectedLessonType = new LessonType();
        this.selectedLevels = [];
        this.selectedLevel = new Level();
        this.selectedRoomColor = '';
        this.roomColors = ['#D0011B', '#F6A623', '#F8E81C', '#7ED321', '#417505', '#BD0FE1', '#9012FE', '#4990E2', '#50E3C2', '#9B9B9B'];
        this.isEditing = false;
        this.isAddingLessonType = false;
        this.isAddingLevel = false;
    }
    get breadcrumbs() {
        const roomName = this.room ? this.room.name : '';
        return [{ name: 'Rooms', path: '/rooms' }, { name: roomName ? roomName.toString() : '', path: this.$route.path }];
    }
    get lessonTypesTableOptions() {
        return {
            headers: [{ text: this.$t('name.title'), value: 'name' }],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, lessonType) => {
                        this.selectedLessonType = lessonType;
                        this.$store.dispatch('openDialog', this.deleteSingleLessonTypeDialogOptions);
                    },
                },
            ],
            dropdown: [],
            filters: [],
            model: new LessonType().filter('rooms', [this.room ? this.room.id : null]),
        };
    }
    get LevelsTableOptions() {
        return {
            headers: [{ text: this.$t('name.title'), value: 'name' }],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, level) => {
                        this.selectedLevel = level;
                        this.$store.dispatch('openDialog', this.deleteSingleLevelDialogOptions);
                    },
                },
            ],
            dropdown: [],
            filters: [],
            model: new Level().filter('rooms', [this.room ? this.room.id : null]),
        };
    }
    get deleteSingleLessonTypeDialogOptions() {
        const lessonType = this.selectedLessonType;
        return {
            title: lessonType.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.lessonType') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.room) {
                            return;
                        }
                        const lesson_types = this.room.lesson_types
                            .filter((lessonType) => {
                            return lessonType.id !== this.selectedLessonType.id;
                        })
                            .map((lessonType) => {
                            return lessonType.id;
                        });
                        this.room
                            .include(['lesson_types', 'levels'])
                            .update({
                            lesson_types,
                        })
                            .then((room) => {
                            this.room = room;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedLessonType = new LessonType();
                    },
                },
            },
        };
    }
    get deleteSingleLevelDialogOptions() {
        const level = this.selectedLevel;
        return {
            title: level.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.level') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.room) {
                            return;
                        }
                        const levels = this.room.levels
                            .filter((level) => level.id !== this.selectedLevel.id)
                            .map((level) => level.id);
                        this.room
                            .include(['lesson_types', 'levels'])
                            .update({
                            levels,
                        })
                            .then((room) => {
                            this.room = room;
                            this.levels = [];
                            room.lesson_types.forEach((level) => {
                                if (level.id) {
                                    this.levels.push(level.id);
                                }
                            });
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedLessonType = new LessonType();
                    },
                },
            },
        };
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                this.initialize();
            },
        }));
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        new RoomModel()
            .include(['name', 'color', 'capacity', 'lesson_types', 'levels'])
            .find(this.$route.params.id)
            .then((room) => {
            this.room = room;
            this.editableRoom = room.clone();
            this.selectedRoomColor = room.color || '';
        });
    }
    update() {
        if (!this.editableRoom) {
            return;
        }
        this.editableRoom.color = this.selectedRoomColor;
        delete this.editableRoom.lesson_types;
        delete this.editableRoom.levels;
        this.editableRoom
            .include(['name', 'color', 'capacity', 'lesson_types', 'levels'])
            .update()
            .then((room) => {
            this.isEditing = false;
            this.room = room;
            this.editableRoom = room.clone();
            this.$emit('update', room);
        })
            .catch((error) => ErrorHandler.network(error));
    }
    resetRoom() {
        if (!this.room) {
            return;
        }
        this.editableRoom = this.room.clone();
    }
};
Room = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            AddLessonTypeDialog,
            AddLevelDialog,
        },
    })
], Room);
export default Room;
